var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isVisible
    ? _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.isBusy,
              expression: "isBusy",
            },
          ],
          staticClass: "media-dialog",
        },
        [
          _c("div", { staticClass: "media-dialog__header" }, [
            _c(
              "button",
              {
                staticClass: "border-0 bg-transparent",
                on: { click: _vm.close },
              },
              [_c("i", { staticClass: "fas fa-2x fa-times" })]
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "media-dialog__body text-left" },
            [
              _c(_vm.getComponent, {
                tag: "component",
                attrs: {
                  model: _vm.form,
                  "pending-message-index-url": _vm.pendingMessageIndexUrl,
                  "store-pending-message-url": _vm.storePendingMessageUrl,
                  "conversation-id": _vm.getConversationId,
                },
                on: { cancel: _vm.onCancel, stored: _vm.onStored },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "media-dialog__footer text-center" }),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }